import Vue from 'vue'
import frontend from './front-end.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Axios from 'axios'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueCookies from 'vue-cookies'
import vuetify from './plugins/vuetify'

import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

Vue.prototype.$http = Axios

const opts = {
  theme: {
    dark: true,
    themes: {
      light: {
        primary: '#42a5f5'

      },
      dark: {
        primary: '#ff0040'
      }
    }
  }
}

Vue.use(Vuetify, BootstrapVue, VueCookies, VueHammer)

new Vue({
  BootstrapVue,
  router,
  vuetify,
  render: g => g(frontend)
}).$mount('#frontend')
